import { createAction, props } from '@ngrx/store';

export const SetAuthenticationStatus = createAction(
  '[Auth] Set Authentication Status',
  props<{ isAuthenticated: boolean }>(),
);

export const ClearAuthenticationStatus = createAction('[Auth] Clear Authentication Status');
